const ActiveTabHighlighter = (urlPath, currentPath) => {
  const url          = removeSlashesExceptForHomePath(urlPath);
  const activeTabURL = removeSlashesExceptForHomePath(currentPath);

  return url.includes(activeTabURL);
};

const removeSlashesExceptForHomePath = path => {
  if (isHome(path)) {
    return retainSlashForHomePath();
  } else {
    return pathWithoutSlashes(path);
  }
};

const isHome = path => {
  return path === '/';
};

const retainSlashForHomePath = () => {
  return '/';
};

const pathWithoutSlashes = path => {
  const forwardSlashes = /\//g;
  const none           = '';

  return path.replace(forwardSlashes, none);
};

export default ActiveTabHighlighter;



// WEBPACK FOOTER //
// ./src/utils/activeTabHighlighter.js